import { useEffect } from 'preact/compat'
import tuiFonts from '@tui/ui-library/scss/themes/tui/fonts.json'
import tuiLightFonts from '@tui/ui-library/scss/themes/tui-light/fonts.json'
import lturFonts from '@tui/ui-library/scss/themes/ltur/fonts.json'
import airtoursFonts from '@tui/ui-library/scss/themes/airtours/fonts.json'
import crystalskiFonts from '@tui/ui-library/scss/themes/crystalski/fonts.json'
import firstchoiceFonts from '@tui/ui-library/scss/themes/firstchoice/fonts.json'
import sundealsFonts from '@tui/ui-library/scss/themes/sundeals/fonts.json'
import robinsonFonts from '@tui/ui-library/scss/themes/robinson/fonts.json'
import tuimagiclifeFonts from '@tui/ui-library/scss/themes/tuimagiclife/fonts.json'
import { dispatchPaymentDetailsIframeEvent } from '../helpers/events'

const attachTUIFontFace = theme => {
  const THEME_FONTS = {
    tui: tuiFonts,
    'tui-light': tuiLightFonts,
    ltur: lturFonts,
    airtours: airtoursFonts,
    crystalski: crystalskiFonts,
    firstchoice: firstchoiceFonts,
    robinson: robinsonFonts,
    tuimagiclife: tuimagiclifeFonts,
    sundeals: sundealsFonts,
  }

  if (!Object.keys(THEME_FONTS).includes(theme)) return Promise.resolve()

  return Promise.all(
    THEME_FONTS[theme].map(async ({ path, display, weight, family, style }) => {
      const font = new FontFace(`${family}`, `url(${path})`, {
        style,
        weight,
        display,
      })

      const fontFace = await font.load()

      document.fonts.add(fontFace)
    }),
  )
}

export default function useTheme({
  transactionThemeValue,
  attributeThemeValue,
  setCurrentTheme,
  iframeRef,
}) {
  useEffect(() => {
    const theme = attributeThemeValue || transactionThemeValue || 'tui-light'

    setCurrentTheme(theme)
    attachTUIFontFace(theme)

    dispatchPaymentDetailsIframeEvent(
      {
        type: 'PaymentsMFEChangeAttribute',
        data: {
          attributeName: 'theme',
          value: theme,
        },
      },
      iframeRef?.current?.contentWindow,
    )
  }, [attributeThemeValue, transactionThemeValue])
}
